<div class="root-container">
  <i class="bi bi-info-circle-fill" [style.font-size.px]="size()"></i>
  <div [class]="['content', floatPosition()]">
    <ng-content></ng-content>
  </div>
</div>
